<template>
	<div class="panel panel-default" style="padding: 0px; margin: 0px;">
		<div class="panel-heading">
			<h3 class="panel-title">
				<span class="status-accordion" v-on:click="popStatus()"><i class="fa" v-bind:class="{'fa-minus-square-o':obj.selected,'fa-plus-square-o':!obj.selected}"></i>&nbsp;</span>				{{obj.desc}}
			</h3>
		</div>
		<div class="panel-body" v-show="obj.selected">
			<p v-show="obj.Points.length==0" class="text-info text-center" style="margin:0;">请点击“<a @click="$emit('calcu')">开始</a> ”按钮</p>
			<my-component-output-uml v-show="obj.Points.length!=0" :obj="obj" @changeline="$emit('linechange',$event)" @changestatus="$emit('statuschange',$event)"></my-component-output-uml>
			<my-component-status v-for="point in obj.Points" :key="point.id" :name="point.desc" :mark="point.mark" :value="point.value"
				:atm="atm" @changeactive="$emit('statuschange',$event)"></my-component-status>
				<my-component-line v-for="line in obj.Lines" :key="line.id" :item="line" @changeactive="$emit('linechange',$event)"></my-component-line>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['obj', 'atm'],
		computed: {},
		methods: {
			popStatus: function () {
				this.obj.selected = !this.obj.selected
			},
		}
	}

</script>

<style>

</style>


// WEBPACK FOOTER //
// output-panel.vue?36635f21